import { onMounted as Pe, nextTick as ze, getCurrentScope as $e, onScopeDispose as ke, unref as j, getCurrentInstance as Ie, ref as R, watch as Q, computed as D, defineComponent as Ze, toRef as se, onUnmounted as De, openBlock as Ue, createElementBlock as qe, normalizeClass as He, normalizeStyle as Ke, createElementVNode as Ce, renderSlot as Ae } from "vue";
function Ee(e) {
  return $e() ? (ke(e), !0) : !1;
}
function Te(e) {
  return typeof e == "function" ? e() : j(e);
}
const me = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Je = (e) => e != null, Qe = Object.prototype.toString, Ne = (e) => Qe.call(e) === "[object Object]", et = () => {
};
function tt(e) {
  return e || Ie();
}
function nt(e, o = !0, s) {
  tt() ? Pe(e, s) : o ? e() : ze(e);
}
function ae(e) {
  var o;
  const s = Te(e);
  return (o = s == null ? void 0 : s.$el) != null ? o : s;
}
const Se = me ? window : void 0;
me && window.document;
me && window.navigator;
me && window.location;
function _e(...e) {
  let o, s, t, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([s, t, r] = e, o = Se) : [o, s, t, r] = e, !o)
    return et;
  Array.isArray(s) || (s = [s]), Array.isArray(t) || (t = [t]);
  const n = [], i = () => {
    n.forEach((d) => d()), n.length = 0;
  }, c = (d, p, y, E) => (d.addEventListener(p, y, E), () => d.removeEventListener(p, y, E)), f = Q(
    () => [ae(o), Te(r)],
    ([d, p]) => {
      if (i(), !d)
        return;
      const y = Ne(p) ? { ...p } : p;
      n.push(
        ...s.flatMap((E) => t.map((C) => c(d, E, C, y)))
      );
    },
    { immediate: !0, flush: "post" }
  ), M = () => {
    f(), i();
  };
  return Ee(M), M;
}
function ot() {
  const e = R(!1), o = Ie();
  return o && Pe(() => {
    e.value = !0;
  }, o), e;
}
function je(e) {
  const o = ot();
  return D(() => (o.value, Boolean(e())));
}
function st(e, o, s = {}) {
  const { window: t = Se, ...r } = s;
  let n;
  const i = je(() => t && "MutationObserver" in t), c = () => {
    n && (n.disconnect(), n = void 0);
  }, f = D(() => {
    const y = Te(e), E = (Array.isArray(y) ? y : [y]).map(ae).filter(Je);
    return new Set(E);
  }), M = Q(
    () => f.value,
    (y) => {
      c(), i.value && t && y.size && (n = new MutationObserver(o), y.forEach((E) => n.observe(E, r)));
    },
    { immediate: !0, flush: "post" }
  ), d = () => n == null ? void 0 : n.takeRecords(), p = () => {
    c(), M();
  };
  return Ee(p), {
    isSupported: i,
    stop: p,
    takeRecords: d
  };
}
function at(e, o, s = {}) {
  const { window: t = Se, ...r } = s;
  let n;
  const i = je(() => t && "ResizeObserver" in t), c = () => {
    n && (n.disconnect(), n = void 0);
  }, f = D(() => Array.isArray(e) ? e.map((p) => ae(p)) : [ae(e)]), M = Q(
    f,
    (p) => {
      if (c(), i.value && t) {
        n = new ResizeObserver(o);
        for (const y of p)
          y && n.observe(y, r);
      }
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    c(), M();
  };
  return Ee(d), {
    isSupported: i,
    stop: d
  };
}
function rt(e, o = {}) {
  const {
    reset: s = !0,
    windowResize: t = !0,
    windowScroll: r = !0,
    immediate: n = !0
  } = o, i = R(0), c = R(0), f = R(0), M = R(0), d = R(0), p = R(0), y = R(0), E = R(0);
  function C() {
    const w = ae(e);
    if (!w) {
      s && (i.value = 0, c.value = 0, f.value = 0, M.value = 0, d.value = 0, p.value = 0, y.value = 0, E.value = 0);
      return;
    }
    const b = w.getBoundingClientRect();
    i.value = b.height, c.value = b.bottom, f.value = b.left, M.value = b.right, d.value = b.top, p.value = b.width, y.value = b.x, E.value = b.y;
  }
  return at(e, C), Q(() => ae(e), (w) => !w && C()), st(e, C, {
    attributeFilter: ["style", "class"]
  }), r && _e("scroll", C, { capture: !0, passive: !0 }), t && _e("resize", C, { passive: !0 }), nt(() => {
    n && C();
  }), {
    height: i,
    bottom: c,
    left: f,
    right: M,
    top: d,
    width: p,
    x: y,
    y: E,
    update: C
  };
}
function Be(e) {
  return e * 180 / Math.PI;
}
function Fe(e) {
  return e * Math.PI / 180;
}
function ce(e, o, s) {
  return Math.min(Math.max(e, o), s);
}
function Re(e, o) {
  return Math.atan2(o[1] - e[1], o[0] - e[0]);
}
function pe(e, o, s) {
  const [t, r] = e, [n, i] = o, c = Math.cos(s) * (t - n) - Math.sin(s) * (r - i) + n, f = Math.sin(s) * (t - n) + Math.cos(s) * (r - i) + i;
  return [c, f];
}
function he(e, o) {
  const s = Math.pow(10, o);
  return Math.round(e * s) / s;
}
function lt({
  wrapperInnerWidth: e,
  wrapperInnerHeight: o,
  canvasNaturalWidth: s,
  canvasNaturalHeight: t,
  translate: r,
  rotate: n,
  scale: i,
  offset: c,
  rotationEnabled: f,
  minScale: M,
  maxScale: d,
  naturalScale: p,
  clientCoordsToWrapperCoords: y,
  getCanvasCoords: E,
  calcProjectionTranslate: C
}) {
  let w = null, b = [0, 0];
  const F = (x) => Array.from(x).map((S) => {
    const T = y(S.clientX, S.clientY);
    return {
      client: [S.clientX, S.clientY],
      canvasRel: E(T[0], T[1])
    };
  });
  return {
    handleTouchstart: (x) => {
      x.target.closest(".matrix") === null && (x.preventDefault(), w = F(x.touches), i.value, b = [r.value[0], r.value[1]], n.value);
    },
    handleTouchmove: (x) => {
      if (x.target.closest(".matrix") !== null)
        return;
      x.preventDefault();
      const T = Array.from(x.touches).map((O) => y(O.clientX, O.clientY));
      if (w)
        if (T.length >= 2 && w.length >= 2) {
          const O = [
            w[0].canvasRel[0] * s.value,
            w[0].canvasRel[1] * t.value
          ], z = [
            w[1].canvasRel[0] * s.value,
            w[1].canvasRel[1] * t.value
          ], I = Math.sqrt(
            Math.pow(O[0] - z[0], 2) + Math.pow(O[1] - z[1], 2)
          ), u = Math.sqrt(
            Math.pow(T[0][0] - T[1][0], 2) + Math.pow(T[0][1] - T[1][1], 2)
          ) / p.value, h = ce(u / I, M.value, d.value), P = [
            T[0][0] / e.value,
            T[0][1] / o.value
          ], _ = w[0].canvasRel, [G, Y] = C(h, P, _, 0);
          let L = 0, N = 0, Z = 0;
          if (f.value) {
            let U = function(le, te) {
              return [
                c.value.left + s.value * le * p.value * h + G,
                c.value.top + t.value * te * p.value * h + Y
              ];
            };
            const ee = Re(O, z);
            Z = Re(
              T[0],
              T[1]
            ) - ee, console.log("startAngle", ee);
            const V = U(0, 0), B = U(
              w[0].canvasRel[0],
              w[0].canvasRel[1]
            ), $ = pe(
              V,
              B,
              Z
            );
            L = $[0] - V[0], N = $[1] - V[1];
          }
          i.value = h, n.value = Z, r.value = [G + L, Y + N], console.log("scale", i.value), console.log("rotate", n.value), console.log("translate", r.value[0], r.value[1]);
        } else {
          const O = x.touches[0].clientX - w[0].client[0], z = x.touches[0].clientY - w[0].client[1], I = [b[0] + O, b[1] + z];
          r.value = I;
        }
    },
    handleTouchend: (x) => {
      x.target.closest(".matrix") === null && (x.touches.length === 0 ? w = null : (w = F(x.touches), i.value, b = [r.value[0], r.value[1]], n.value));
    }
  };
}
function ut(e) {
  var o = !1;
  return e.wheelDeltaY ? e.wheelDeltaY === e.deltaY * -3 && (o = !0) : e.deltaMode === 0 && (o = !0), o;
}
function Ye(e, o) {
  const s = o.find((t) => e % t === 0);
  return s ? e / s : 1;
}
function it({
  scale: e,
  translate: o,
  minScale: s,
  maxScale: t,
  relativeWrapperCoordinatesFromClientCoords: r,
  normalizeMatrixCoordinates: n,
  calcProjectionTranslate: i
}) {
  function c(f) {
    let { deltaX: M, deltaY: d, ctrlKey: p } = f;
    const y = [120, 100], E = 2;
    ut(f) || ((Math.abs(M) === 120 || Math.abs(M) === 200) && (M = M / (100 / E * Ye(M, y)) * Math.sign(M)), (Math.abs(d) === 120 || Math.abs(d) === 200) && (d = d / (100 / E * Ye(d, y)) * Math.sign(d)));
    const C = e.value;
    if (p) {
      const w = -d / 100 * C, b = ce(C + w, s.value, t.value), [F, H] = i(
        b,
        r(f.clientX, f.clientY),
        n(f.clientX, f.clientY)
      );
      o.value = [F, H], e.value = b;
    } else
      o.value = [o.value[0] - M, o.value[1] - d];
    f.preventDefault(), f.stopPropagation();
  }
  return {
    handleWheel: c
  };
}
function ct(e) {
  let o = null, s = null, t = null;
  return {
    handleMousedown: (c) => {
      c.preventDefault(), o = [c.clientX, c.clientY], s = e.value[0], t = e.value[1];
    },
    handleMouseup: (c) => {
      c.preventDefault(), o = null, s = null, t = null;
    },
    handleMousemove: (c) => {
      if (c.preventDefault(), o && s !== null && t !== null) {
        const f = c.clientX - o[0], M = c.clientY - o[1], d = s - -f, p = t - -M;
        e.value = [d, p];
      }
    }
  };
}
function dt(e, o, s, t) {
  let r = 0;
  return {
    handleGesturestart: (f) => {
      r = e.value;
    },
    handleGesturechange: (f) => {
      if (o.value === !1)
        return;
      const M = f.rotation;
      if (M === 0)
        return;
      const d = t(f.clientX, f.clientY);
      s(d[0], d[1], r + Fe(M));
    },
    handleGestureend: (f) => {
    }
  };
}
function ft({
  wrapperElementRef: e,
  canvasNaturalWidth: o,
  canvasNaturalHeight: s,
  offset: t,
  bounds: r,
  rotationEnabled: n,
  minScale: i,
  maxScale: c
}) {
  const { x: f, y: M, width: d, height: p } = rt(e), y = D(() => ({
    x: f.value,
    y: M.value,
    width: d.value,
    height: p.value
  })), E = D(() => f.value + t.value.left), C = D(() => M.value + t.value.top), w = D(() => d.value - t.value.left - t.value.right), b = D(() => p.value - t.value.top - t.value.bottom), F = D(() => w.value / b.value), H = D(() => o.value / s.value), W = D(() => H.value >= F.value ? w.value / o.value : b.value / s.value), A = (() => {
    const l = R(0), v = R(0);
    return D({
      get() {
        return [l.value, v.value];
      },
      set([m, g]) {
        const a = o.value * T.value - w.value, X = s.value * T.value - b.value;
        if (n.value || !r.value)
          l.value = m, v.value = g;
        else {
          const k = -a, q = Math.max(0, -a / 2), J = -X, oe = Math.max(0, -X / 2);
          l.value = ce(m, k, q), v.value = ce(g, J, oe);
        }
      }
    });
  })(), x = (() => {
    const l = R(1);
    return D({
      get() {
        return l.value;
      },
      set(v) {
        l.value = ce(v, i.value, c.value);
      }
    });
  })(), S = (() => {
    const l = R(0);
    return D({
      get() {
        return l.value;
      },
      set(v) {
        l.value = v;
      }
    });
  })(), T = D(() => x.value * W.value), O = D(() => [t.value.left + A.value[0], t.value.top + A.value[1]]), z = D(() => S.value), I = R(!1), u = R(0.3);
  let h = !1;
  function P(l, v, m, g = !1) {
    const a = B(l, v, m, 0);
    x.value = l, A.value = a, I.value = g, h = !0, ze(() => {
      h = !1;
    }), setTimeout(() => {
      I.value = !1;
    }, u.value * 1e3);
  }
  Q([z, T, O], () => {
    h || (I.value = !1);
  });
  function _(l, v, m) {
    const g = B(l, [0.5, 0.5], [0.5, 0.5], 0), a = [
      t.value.left + g[0] + o.value * (l * W.value) * 0.5,
      t.value.top + g[1] + s.value * (l * W.value) * 0.5
    ], X = K(0.5, 0.5, l, v, m), k = X[0] - a[0], q = X[1] - a[1];
    return [k, q];
  }
  function G() {
    const l = _(x.value, [0, 0], S.value);
    return {
      x: he(A.value[0] + l[0], 6),
      y: he(A.value[1] + l[1], 6),
      scale: he(x.value, 6),
      rotate: he(Be(S.value), 6)
    };
  }
  const Y = D({
    get() {
      return G();
    },
    set(l) {
      const v = G();
      if (l.x === v.x && l.y === v.y && l.scale === v.scale && l.rotate === v.rotate)
        return;
      const m = Fe(l.rotate), g = _(l.scale, [0, 0], m);
      A.value = [l.x - g[0], l.y - g[1]], x.value = l.scale, S.value = m;
    }
  });
  function L(l, v) {
    return [l - E.value, v - C.value];
  }
  function N(l, v) {
    const [m, g] = L(l, v);
    return [m / w.value, g / b.value];
  }
  function Z(l, v) {
    const m = [0, 0], g = [l - A.value[0], v - A.value[1]], a = pe(g, m, -S.value), X = [a[0] / T.value, a[1] / T.value];
    return [X[0] / o.value, X[1] / s.value];
  }
  function U(l, v) {
    const m = L(l, v);
    return Z(m[0], m[1]);
  }
  function ee(l, v) {
    const [m, g] = U(l, v);
    return [m * o.value, g * s.value];
  }
  function K(l, v, m, g, a) {
    m = m != null ? m : x.value, g = g != null ? g : A.value, a = a != null ? a : S.value;
    const X = [t.value.left, t.value.top], k = [
      t.value.left + o.value * (m * W.value) * l,
      t.value.top + s.value * (m * W.value) * v
    ], q = pe(k, X, a);
    return [q[0] + g[0], q[1] + g[1]];
  }
  function V(l, v) {
    const m = l / o.value, g = v / s.value;
    return K(m, g);
  }
  function B(l, v, m, g) {
    const a = o.value * W.value, X = s.value * W.value, k = m[0] * a * l, q = m[1] * X * l, J = pe([k, q], [0, 0], g != null ? g : S.value), oe = v[0] * w.value, we = v[1] * b.value, xe = oe - J[0], Ve = we - J[1];
    return [xe, Ve];
  }
  function $(l, v, m) {
    const g = m, a = _(x.value, [0, 0], g), X = [0 - a[0], 0 - a[1]], k = x.value, J = K(l, v, k, X, g), oe = K(l, v), we = oe[0] - J[0], xe = oe[1] - J[1];
    A.value = [X[0] + we, X[1] + xe], S.value = g;
  }
  const { handleTouchend: le, handleTouchmove: te, handleTouchstart: de } = lt({
    wrapperInnerWidth: w,
    wrapperInnerHeight: b,
    canvasNaturalWidth: o,
    canvasNaturalHeight: s,
    translate: A,
    rotate: S,
    scale: x,
    offset: t,
    rotationEnabled: n,
    minScale: i,
    maxScale: c,
    naturalScale: W,
    clientCoordsToWrapperCoords: L,
    getCanvasCoords: Z,
    calcProjectionTranslate: B
  }), { handleWheel: ue } = it({
    scale: x,
    translate: A,
    minScale: i,
    maxScale: c,
    relativeWrapperCoordinatesFromClientCoords: N,
    normalizeMatrixCoordinates: U,
    calcProjectionTranslate: B
  }), { handleMousedown: ne, handleMouseup: ge, handleMousemove: fe } = ct(A), { handleGesturestart: ve, handleGesturechange: Me, handleGestureend: ie } = dt(
    S,
    n,
    $,
    U
  );
  return {
    handleTouchend: le,
    handleTouchmove: te,
    handleTouchstart: de,
    handleGesturestart: ve,
    handleGesturechange: Me,
    handleGestureend: ie,
    translate: A,
    scale: x,
    rotate: S,
    renderingScale: T,
    renderingTranslate: O,
    renderingRotate: z,
    exposedTransform: Y,
    rotateCanvas: $,
    calcProjectionTranslate: B,
    clientCoordsToWrapperCoords: L,
    getCanvasCoords: Z,
    normalizeMatrixCoordinates: U,
    clientCoordinatesToCanvasCoordinates: ee,
    composePoint: K,
    compose: V,
    handleWheel: ue,
    applyTransform: P,
    handleMousedown: ne,
    handleMouseup: ge,
    handleMousemove: fe,
    wrapperBounds: y,
    transitionEnabled: I,
    transitionDuration: u,
    wrapperX: f,
    wrapperY: M,
    wrapperWidth: d,
    wrapperHeight: p
  };
}
const vt = 0.996, ht = (e, o = vt) => e * o / (1 - o);
function pt(e) {
  return e[e.length - 1];
}
function mt(e) {
  return e.reduce((o, s) => o + s) / e.length;
}
const gt = (e, o, s) => Math.min(Math.max(o, e), s);
function ye(e, o) {
  if (e.length !== o.length)
    throw new Error("vectors must be same length");
  return e.map((s, t) => s + o[t]);
}
function Xe(e) {
  return Math.max(...e.map(Math.abs));
}
function re(e) {
  return Object.freeze(e), Object.values(e).forEach((o) => {
    o !== null && typeof o == "object" && !Object.isFrozen(o) && re(o);
  }), e;
}
function Mt() {
  const e = {};
  function o(r, n) {
    return e[r] = (e[r] || []).concat(n), () => s(r, n);
  }
  function s(r, n) {
    e[r] = (e[r] || []).filter((i) => i !== n);
  }
  function t(r, n) {
    r in e && e[r].forEach((i) => i(n));
  }
  return re({
    on: o,
    off: s,
    dispatch: t
  });
}
function wt(e) {
  let o = [];
  const s = (n) => (n.addEventListener("wheel", e, { passive: !1 }), o.push(n), () => t(n)), t = (n) => {
    n.removeEventListener("wheel", e), o = o.filter((i) => i !== n);
  };
  return re({
    observe: s,
    unobserve: t,
    disconnect: () => {
      o.forEach(t);
    }
  });
}
const xt = 16 * 1.125, yt = typeof window < "u" && window.innerHeight || 800, be = [1, xt, yt];
function bt(e) {
  const o = e.deltaX * be[e.deltaMode], s = e.deltaY * be[e.deltaMode], t = (e.deltaZ || 0) * be[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [o, s, t]
  };
}
const Pt = [-1, -1, -1];
function Et(e, o) {
  if (!o)
    return e;
  const s = o === !0 ? Pt : o.map((t) => t ? -1 : 1);
  return {
    ...e,
    axisDelta: e.axisDelta.map((t, r) => t * s[r])
  };
}
const Oe = 700, Tt = (e) => ({
  ...e,
  axisDelta: e.axisDelta.map((o) => gt(o, -Oe, Oe))
}), St = 0.6, Dt = 0.96, Ct = 2, Ge = 5, We = re({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), At = 400;
function Le() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: At
  };
}
function _t(e = {}) {
  const { on: o, off: s, dispatch: t } = Mt();
  let r = We, n = Le(), i, c = !1, f;
  const M = (u) => {
    Array.isArray(u) ? u.forEach((h) => E(h)) : E(u);
  }, d = (u = {}) => Object.values(u).some((h) => h == null) ? r : r = re({ ...We, ...r, ...u }), p = (u) => {
    const h = {
      event: i,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: n.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: n.axisVelocity,
      axisMovement: n.axisMovement,
      get axisMovementProjection() {
        return ye(
          h.axisMovement,
          h.axisVelocity.map((P) => ht(P))
        );
      },
      ...u
    };
    t("wheel", {
      ...h,
      previous: f
    }), f = h;
  }, y = (u, h) => {
    const { preventWheelAction: P } = r, [_, G, Y] = h;
    if (typeof P == "boolean")
      return P;
    switch (P) {
      case "x":
        return Math.abs(_) >= u;
      case "y":
        return Math.abs(G) >= u;
      case "z":
        return Math.abs(Y) >= u;
      default:
        return !1;
    }
  }, E = (u) => {
    const { axisDelta: h, timeStamp: P } = Tt(
      Et(bt(u), r.reverseSign)
    ), _ = Xe(h);
    if (u.preventDefault && y(_, h) && u.preventDefault(), n.isStarted ? n.isMomentum && _ > Math.max(2, n.lastAbsDelta * 2) && (T(!0), x()) : x(), _ === 0 && Object.is && Object.is(u.deltaX, -0)) {
      c = !0;
      return;
    }
    i = u, n.axisMovement = ye(n.axisMovement, h), n.lastAbsDelta = _, n.scrollPointsToMerge.push({
      axisDelta: h,
      timeStamp: P
    }), C(), p({ axisDelta: h, isStart: !n.isStartPublished }), n.isStartPublished = !0, S();
  }, C = () => {
    n.scrollPointsToMerge.length === Ct ? (n.scrollPoints.unshift({
      axisDeltaSum: n.scrollPointsToMerge.map((u) => u.axisDelta).reduce(ye),
      timeStamp: mt(n.scrollPointsToMerge.map((u) => u.timeStamp))
    }), b(), n.scrollPointsToMerge.length = 0, n.scrollPoints.length = 1, n.isMomentum || W()) : n.isStartPublished || w();
  }, w = () => {
    n.axisVelocity = pt(n.scrollPointsToMerge).axisDelta.map((u) => u / n.willEndTimeout);
  }, b = () => {
    const [u, h] = n.scrollPoints;
    if (!h || !u)
      return;
    const P = u.timeStamp - h.timeStamp;
    if (P <= 0)
      return;
    const _ = u.axisDeltaSum.map((Y) => Y / P), G = _.map((Y, L) => Y / (n.axisVelocity[L] || 1));
    n.axisVelocity = _, n.accelerationFactors.push(G), F(P);
  }, F = (u) => {
    let h = Math.ceil(u / 10) * 10 * 1.2;
    n.isMomentum || (h = Math.max(100, h * 2)), n.willEndTimeout = Math.min(1e3, Math.round(h));
  }, H = (u) => u === 0 ? !0 : u <= Dt && u >= St, W = () => {
    if (n.accelerationFactors.length >= Ge) {
      if (c && (c = !1, Xe(n.axisVelocity) >= 0.2)) {
        A();
        return;
      }
      const u = n.accelerationFactors.slice(Ge * -1);
      u.every((P) => {
        const _ = !!P.reduce((Y, L) => Y && Y < 1 && Y === L ? 1 : 0), G = P.filter(H).length === P.length;
        return _ || G;
      }) && A(), n.accelerationFactors = u;
    }
  }, A = () => {
    n.isMomentum = !0;
  }, x = () => {
    n = Le(), n.isStarted = !0, n.startTime = Date.now(), f = void 0, c = !1;
  }, S = (() => {
    let u;
    return () => {
      clearTimeout(u), u = setTimeout(T, n.willEndTimeout);
    };
  })(), T = (u = !1) => {
    !n.isStarted || (n.isMomentum && u ? p({ isEnding: !0, isMomentumCancel: !0 }) : p({ isEnding: !0 }), n.isMomentum = !1, n.isStarted = !1);
  }, { observe: O, unobserve: z, disconnect: I } = wt(M);
  return d(e), re({
    on: o,
    off: s,
    observe: O,
    unobserve: z,
    disconnect: I,
    feedWheel: M,
    updateOptions: d
  });
}
const Rt = 10, Yt = 10, Xt = /* @__PURE__ */ Ze({
  __name: "Zoompinch",
  props: {
    transform: { default: () => ({ x: 0, y: 0, scale: 1, rotate: 0 }) },
    width: {},
    height: {},
    offset: { default: () => ({ left: 0, top: 0, right: 0, bottom: 0 }) },
    maxScale: { default: 10 },
    minScale: { default: 0.5 },
    bounds: { type: Boolean, default: !1 },
    rotation: { type: Boolean, default: !0 },
    mouse: { type: Boolean, default: !0 },
    wheel: { type: Boolean, default: !0 },
    touch: { type: Boolean, default: !0 },
    gesture: { type: Boolean, default: !0 }
  },
  emits: ["update:transform", "dragGestureStart", "dragGestureEnd"],
  setup(e, { expose: o, emit: s }) {
    const t = e, r = s;
    console.log("!!!!!! ZOOMPINCH !!!!!!!", t);
    const n = R(), i = R(), c = R(), f = se(t, "width"), M = se(t, "height"), d = se(t, "offset"), p = D(() => !t.bounds && t.rotation), {
      renderingTranslate: y,
      renderingRotate: E,
      renderingScale: C,
      composePoint: w,
      handleWheel: b,
      handleMousedown: F,
      handleMousemove: H,
      handleMouseup: W,
      handleTouchstart: A,
      handleTouchmove: x,
      handleTouchend: S,
      handleGesturestart: T,
      handleGesturechange: O,
      handleGestureend: z,
      applyTransform: I,
      rotateCanvas: u,
      compose: h,
      exposedTransform: P,
      calcProjectionTranslate: _,
      clientCoordinatesToCanvasCoordinates: G,
      normalizeMatrixCoordinates: Y,
      transitionEnabled: L,
      transitionDuration: N,
      wrapperX: Z,
      wrapperY: U,
      wrapperWidth: ee,
      wrapperHeight: K
    } = ft({
      wrapperElementRef: n,
      canvasNaturalWidth: f,
      canvasNaturalHeight: M,
      offset: d,
      bounds: se(t, "bounds"),
      rotationEnabled: p,
      minScale: se(t, "minScale"),
      maxScale: se(t, "maxScale")
    });
    Q(P, () => {
      (t.transform.rotate !== P.value.rotate || t.transform.scale !== P.value.scale || t.transform.x !== P.value.x || t.transform.y !== P.value.y) && r("update:transform", P.value);
    }), Q(
      () => t.transform,
      () => {
        P.value = {
          x: t.transform.x,
          y: t.transform.y,
          scale: t.transform.scale,
          rotate: t.transform.rotate
        };
      },
      { deep: !0 }
    ), Pe(() => {
    });
    const V = _t();
    V.on("wheel", (a) => {
      a.isStart && r("dragGestureStart", a.event), b(a.event), a.isEnding && r("dragGestureEnd", a.event);
    }), Q([n, () => t.wheel], () => {
      n.value && (t.wheel ? V.observe(n.value) : V.disconnect());
    }), De(() => {
      V.disconnect();
    });
    let B = !1, $ = null;
    const le = (a) => {
      B = !1, $ = { x: a.touches[0].clientX, y: a.touches[0].clientY }, t.touch && (r("dragGestureStart", a), A(a));
    }, te = (a) => {
      $ && Math.sqrt(
        Math.pow(a.touches[0].clientX - $.x, 2) + Math.pow(a.touches[0].clientY - $.y, 2)
      ) > Rt && (B = !0), t.touch && x(a);
    }, de = (a) => {
      t.touch && (S(a), a.composedPath().includes(n.value) && B && r("dragGestureEnd", a));
    };
    let ue = !1, ne = null;
    const ge = (a) => {
      ue = !1, ne = { x: a.clientX, y: a.clientY }, t.mouse && (r("dragGestureStart", a), F(a));
    }, fe = (a) => {
      ne && Math.sqrt(Math.pow(a.clientX - ne.x, 2) + Math.pow(a.clientY - ne.y, 2)) > Yt && (ue = !0), t.mouse && H(a);
    }, ve = (a) => {
      t.mouse && (W(a), a.composedPath().includes(n.value) && ue && r("dragGestureEnd", a));
    };
    function Me() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }
    const ie = D(() => !Me() && t.gesture), l = (a) => {
      ie.value && T(a);
    }, v = (a) => {
      ie.value && O(a);
    }, m = (a) => {
      ie.value && z(a);
    };
    window.addEventListener("touchmove", te), window.addEventListener("touchend", de), window.addEventListener("mouseup", ve), window.addEventListener("mousemove", fe), window.addEventListener("gesturechange", v), window.addEventListener("gestureend", m), De(() => {
      window.removeEventListener("touchmove", te), window.removeEventListener("touchend", de), window.removeEventListener("mouseup", ve), window.removeEventListener("mousemove", fe), window.removeEventListener("gesturechange", v), window.removeEventListener("gestureend", m);
    });
    const g = D(() => ({
      x: Z.value,
      y: U.value,
      width: ee.value,
      height: K.value
    }));
    return o({
      compose: h,
      composePoint: w,
      clientCoordinatesToCanvasCoordinates: G,
      normalizeMatrixCoordinates: Y,
      applyTransform: I,
      calcProjectionTranslate: _,
      rotateCanvas: u,
      wrapperBounds: g,
      canvas: i,
      matrix: c
    }), (a, X) => (Ue(), qe("div", {
      ref_key: "zoompinchRef",
      ref: n,
      class: He(["zoompinch", {
        "transition-enabled": j(L)
      }]),
      style: Ke({
        "--canvas-width": `${a.width}px`,
        "--canvas-height": `${a.height}px`,
        "--canvas-ratio": a.width / a.height,
        "--rendering-scale": j(C),
        "--translate-x": `${j(y)[0]}px`,
        "--translate-y": `${j(y)[1]}px`,
        "--rotate": `${j(Be)(j(E))}deg`,
        "--offset-top": `${t.offset.top}px`,
        "--offset-right": `${t.offset.right}px`,
        "--offset-bottom": `${t.offset.bottom}px`,
        "--offset-left": `${t.offset.left}px`,
        "--transition-duration": `${j(N)}s`
      }),
      onTouchstart: le,
      onMousedown: ge,
      onGesturestart: l
    }, [
      Ce("div", {
        ref_key: "canvasRef",
        ref: i,
        class: "canvas"
      }, [
        Ae(a.$slots, "canvas", {}, void 0, !0)
      ], 512),
      Ce("div", {
        ref_key: "matrixRef",
        ref: c,
        class: "matrix"
      }, [
        Ae(a.$slots, "matrix", {
          composePoint: j(w),
          compose: j(h),
          clientCoordinatesToCanvasCoordinates: j(G),
          normalizeMatrixCoordinates: j(Y)
        }, void 0, !0)
      ], 512)
    ], 38));
  }
});
const Ot = (e, o) => {
  const s = e.__vccOpts || e;
  for (const [t, r] of o)
    s[t] = r;
  return s;
}, Wt = /* @__PURE__ */ Ot(Xt, [["__scopeId", "data-v-55dbc0c0"]]);
export {
  Wt as Zoompinch
};
